import type { JSX } from 'react';

import { Alert, AlertDescription } from '../Alert/Alert';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';

import styles from './OfflineBanner.module.css';

/**
 * Persistent affordance shown while the browser is offline. Explains that the
 * app is running against cached data and that edits are paused (mutations are
 * blocked by the Apollo offline guard until connectivity returns).
 */
export function OfflineBanner(): JSX.Element | null {
  const online = useOnlineStatus();

  if (online) {
    return null;
  }

  return (
    <div className={styles.Container} role="status" aria-live="polite">
      <Alert variant="warning" className={styles.Alert}>
        <AlertDescription>
          You&apos;re offline. Showing cached data — changes are paused until you reconnect.
        </AlertDescription>
      </Alert>
    </div>
  );
}

export default OfflineBanner;
